import { usePodcastProvider, ModalType } from "components/podcast/PodcastProvider";

//ui
import { Box, Flex } from "@chakra-ui/react";
import { EpisodeDetailsModalContent, SubscribeModalContent, ShareModalContent, DownloadModalContent } from "./ModalContents";

export function SmallScreenPodcastModal() {
  const { isOpen, modalType } = usePodcastProvider();

  const ModalTypeContent = () => {
    switch (modalType) {
      case ModalType.Details:
        return <EpisodeDetailsModalContent />;
      case ModalType.Subscribe:
        return <SubscribeModalContent />;
      case ModalType.Share:
        return <ShareModalContent />;
      case ModalType.Download:
        return <DownloadModalContent />;
    }
  };
  const showContent = isOpen ? "flex" : "none";
  return (
    <Flex fontFamily="sora">
      <Box width="100%" display={{ base: showContent, md: "none" }}>
        {ModalTypeContent()}
      </Box>
    </Flex>
  );
}
